import { useMemo } from 'react';
import { useFilesBase, FileListItem } from './use-files-base';

const dummyFiles: FileListItem[] = [
  { id: '1', name: 'Proposal_v2_Final.pdf', size: '3.1 MB', date: 'Feb 25, 2026', source: 'email' },
  { id: '2', name: 'SOW_Draft.docx', size: '1.2 MB', date: 'Feb 18, 2026', source: 'email' },
  { id: '3', name: 'Pricing_Schedule.xlsx', size: '450 KB', date: 'Feb 18, 2026', source: 'email' },
];

interface UseDealFilesOptions {
  skip?: boolean;
}

export const useDealFiles = (dealId: string, options: UseDealFilesOptions = {}) => {
  const entityFilter = useMemo(() => ({ dealId }), [dealId]);

  return useFilesBase({
    entityFilter,
    entityId: dealId,
    skip: options.skip,
    dummyFiles,
  });
};
